import { useCallback, useState } from "react";

export function useReveal(total: number, startRevealed = false) {
  const [current, setCurrent] = useState(startRevealed ? Math.max(total - 1, 0) : 0);
  const [open, setOpen] = useState(startRevealed);

  const revealedCount = current + (open ? 1 : 0);

  const openEnvelope = useCallback(() => setOpen(true), []);
  const next = useCallback(() => {
    setOpen(false);
    setCurrent((c) => Math.min(c + 1, Math.max(total - 1, 0)));
  }, [total]);
  const reset = useCallback(() => {
    setCurrent(0);
    setOpen(false);
  }, []);

  return {
    current,
    open,
    revealedCount,
    isLast: current === total - 1,
    allRevealed: total > 0 && revealedCount === total,
    openEnvelope,
    next,
    reset,
  };
}

export type RevealState = ReturnType<typeof useReveal>;
